import React, { useState, useEffect } from 'react';
import PasswordsQueries from '../../../../requests/queries/PasswordsQueries';

const SecretCodesManagement = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [showCreateForm, setShowCreateForm] = useState(false);
    const [selectedCode, setSelectedCode] = useState(null);
    const [codes, setCodes] = useState([]);
    const [error, setError] = useState(null);
  
    const fetchCodes = async () => {
        try {
            setIsLoading(true);
            const res = await PasswordsQueries.findAll();
            if(res.status === 200) {
                setCodes(res.data.passwords);
            } else {
                setError(res.data.message);
            }
            setIsLoading(false);
        } catch (error) {
            setError(error.response.data.message);
            setIsLoading(false);
        }
    }

    const toggleCodeStatus = async (id) => {
      try {
        setIsLoading(true);
        const res = await PasswordsQueries.update(id, { is_active: !codes.find(c => c.id === id).is_active });
        if(res) {
          fetchCodes();
          setError(null);
        }
        setIsLoading(false);
      } catch (error) {
        setError(error.response.data.message || 'Une erreur est survenue');
        setIsLoading(false);
      }
    }
    
    const deleteCode = async (id) => {
      try {
        setIsLoading(true);
        const res = await PasswordsQueries.delete(id);
        if(res) {
          fetchCodes();
          setError(null);
        } else {
          setError(res.data.message || 'Une erreur est survenue');
        }
        setIsLoading(false);
      } catch (error) {
        setError(error.response.data.message || 'Une erreur est survenue');
        setIsLoading(false);
      }
    }

    const handleCreateCode = async (formData) => {
      try {
        setIsLoading(true);
        const res = await PasswordsQueries.create({
          password: formData.password,
          max_uses: formData.max_uses,
          end_time: formData.end_time,
        });
        if(res) {
          fetchCodes();
          setShowCreateForm(false);
          setError(null);
          setIsLoading(false);
        } else {
          setError(res.data.message || 'Une erreur est survenue');
          setIsLoading(false);
        }
      } catch (error) {
        setError(error.response.data.message || 'Une erreur est survenue');
        setIsLoading(false);
    }
  }

    useEffect(() => {
        fetchCodes();
    }, []);

    return (
      <div className="secret-codes-section">
          {error && <div className="error-overlay">
            <div className="error-message">{error}</div>
          </div>}
        <div className="section-header">
          <h2>Codes Secrets - Boutique Exclusive</h2>
          <div className="header-actions">
            <button 
              className="btn btn-outline-primary"
              onClick={() => window.open('/client-secret', '_blank')}
            >
              <i className="bi bi-eye"></i>
              Voir la boutique secrète
            </button>
            <button 
              className="btn btn-primary"
              onClick={() => setShowCreateForm(!showCreateForm)}
            >
              <i className="bi bi-plus-circle"></i>
              Créer un code secret
            </button>
          </div>
        </div>
  
        {showCreateForm && (
          <div className="create-code-form">
            <h3>Nouveau Code Secret</h3>
            <form onSubmit={(e) => {
              e.preventDefault();
              const formData = new FormData(e.target);
              handleCreateCode(Object.fromEntries(formData));
            }}>
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Secret code name</label>
                  <input type="text" name="password" className="form-control" placeholder="Collection Hiver 2024" required />
                </div>
                <div className="form-group">
                  <label className="form-label">Max uses</label>
                  <input type="number" name="max_uses" className="form-control" placeholder="Ex: 1234567890" required />
                </div>
                <div className="form-group">
                  <label className="form-label">Expiration date</label>
                  <input type="date" min={new Date().toISOString().split('T')[0]} name="end_time" className="form-control" required />
                </div>
                <div className="form-group">
                  <button type="submit" className="btn btn-success">Create the code</button>
                  <button type="button" className="btn btn-secondary" onClick={() => setShowCreateForm(false)}>
                    Cancel
                  </button>
              </div>
              </div>
            </form>
          </div>
        )}
  
        <div className="codes-stats">
          <div className="stat-item">
            <h3>Active codes</h3>
            <p className="stat-number">{codes.filter(c => c.is_active && new Date(c.end_time) > new Date()).length}</p>
          </div>
          <div className="stat-item">
            <h3>Expired codes</h3>
            <p className="stat-number">{codes.filter(c => new Date(c.end_time) < new Date()).length}</p>
          </div>
          <div className="stat-item">
            <h3>Default codes</h3>
            <p className="stat-number">{codes.find(c => c.is_default_password)?.password || 'No default code'}</p>
          </div>
        </div>
  
        <div className="codes-list">
          <h3>Existing codes</h3>
          <div className="codes-grid">
            {codes.sort((a, b) => new Date(b.end_time) - new Date(a.end_time)).map(code => (
              <div key={code.id} className={`code-card ${code.is_active ? 'active' : 'inactive'}`}>
                <div className="code-header">
                  <div className="code-info">
                    <h4>{code.password}</h4>
                    <p className="code-value">{code.password}</p>
                  </div>
                  <div className="code-status">
                    <span className={`status-badge ${code.is_active ? 'active' : 'inactive'}`}>
                      {code.is_active ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                </div>
                
                <div className="code-details">
                  <div className="code-stats">
                    <div className="stat">
                      <span className="label">Utilisations:</span>
                      <span className="value">{code.max_uses}</span>
                    </div>
                    <div className="stat">
                      <span className="label">Expire le:</span>
                      <span className="value">{new Date(code.end_time).toLocaleDateString('fr-FR')}</span>
                    </div>
                  </div>
                </div>
                
                <div className="code-actions">
                  <button 
                    className={`btn btn-sm ${code.is_active ? 'btn-warning' : 'btn-success'}`}
                    onClick={() => toggleCodeStatus(code.id)}
                  >
                    <i className="bi bi-toggle"></i>
                    {code.is_active ? 'Disable' : 'Enable'}
                  </button>
                  <button 
                    className="btn btn-sm btn-outline-primary"
                    disabled={code.is_default_password || !code.is_active || new Date(code.end_time) < new Date()}
                    onClick={async () => {
                      const res = await PasswordsQueries.setDefaultPassword(code.id);
                      fetchCodes();
                    }}
                  >
                    <i className="bi bi-star"></i>
                    Set as default
                  </button>
                  <button 
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => deleteCode(code.id)}
                  >
                    <i className="bi bi-trash"></i>
                    Delete the code
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

export default SecretCodesManagement;